import { AppConfig } from '@dh-io-emh/config-types';
import { createHttpService } from '../utils/http.util';

export type ConfigApi = ReturnType<typeof createConfigApiService>;

export const createConfigApiService = () => {
  const http = createHttpService();

  return {
    getAppConfig: (url: string, country: string, language: string): Promise<AppConfig> =>
      http.get<AppConfig>(url).then((res) => {
        const { data } = res;

        data.lang = language;
        // the locale is a combination of a ISO-639 language code and a ISO-3166 Alpha 2 country code
        data.locale = `${language}-${country.toUpperCase()}`;
        data.currency = data.defaultCurrency;
        // reset shopBaseUrl based on the retrieved locale
        data.shopBaseUrl = data.shopBaseUrl.replace(/\/([\w]{2})-([\w]{2})\//g, `/${language}-${country}/`);
        // add configUrl required by legacy checkout
        data.configUrl = url;

        return data;
      }),
    getHybrisConfig: (url: string): Promise<AppConfig> =>
      http.get<AppConfig>(url).then((res) => {
        const { data } = res;

        data.assortments = Object.keys(data.assortmentBaseCategoryMapping || {});

        return data;
      }),
  };
};

export const configApi = createConfigApiService();
